// Light wrapper to native fetch function to apply common attributes to all api calls
// Potentially will replace this with a package

import getEnvVariables from "lib/environmentVariables/getEnvVariables";

const getApiClient =
  (setupData?: { accessToken?: string }): typeof fetch =>
  (path, data) => {
    const headers = {
      "Content-Type": "application/json",
      authorization: setupData?.accessToken ?? "",
      ...data?.headers,
    };

    // TODO: Make this more robust (e.g. Check if path passed in is actually a full url)
    const fullUrl = `${getEnvVariables().idApiUrl}${path}`;

    return fetch(fullUrl, {
      credentials: "include",
      ...data,
      headers,
    });
  };

export default getApiClient;
